import type { WrapperFC } from '@george-labs.com/design-system';
import { StripeActionButton } from '@george-labs.com/design-system';

import type { Props } from './DetailPageStripeRightButton';
import { DetailPageStripeRightButton } from './DetailPageStripeRightButton';

export const DetailPageStripeRightActionButton: WrapperFC<Props> = (props) => {
    return <DetailPageStripeRightButton {...props} ButtonComponent={StripeActionButton} />;
};

DetailPageStripeRightActionButton.wrapsComponent = StripeActionButton;
